import { render, staticRenderFns } from "./ColdCall.vue?vue&type=template&id=79b0ae49&scoped=true"
import script from "./ColdCall.vue?vue&type=script&lang=js"
export * from "./ColdCall.vue?vue&type=script&lang=js"
import style0 from "./ColdCall.vue?vue&type=style&index=0&id=79b0ae49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0ae49",
  null
  
)

export default component.exports